import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MessengerRoutingModule } from './messenger-routing.module';
import { ChatListPageComponent } from './chat-list-page/chat-list-page.component';
import { ChatPageComponent } from './chat-page/chat-page.component';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '@shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MessageItemComponent } from '@modules/messenger/message-item/message-item.component';
import { ChatListItemComponent } from './chat-list-item/chat-list-item.component';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NewChatUserSearchComponent } from './new-chat-user-search/new-chat-user-search.component';


@NgModule({
  declarations: [
    ChatListPageComponent,
    ChatPageComponent,
    MessageItemComponent,
    ChatListItemComponent,
    NewChatUserSearchComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    MessengerRoutingModule,
    MatListModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    TextFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    SharedModule,
  ],
})
export class MessengerModule {
}
